<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      hide-required-asterisk
    >
      <form-box v-if="viewForm" :title="$t('hzmbG.title.application')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.approveNo')">
                <el-input v-model="viewForm.approveNo" disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbGInsurance.label.registrationType')"
              >
                <el-select v-model="viewForm.registrationType" disabled>
                  <el-option
                    v-for="item in HKVEHICLEREGISTERTYPE"
                    :key="item"
                    :value="item"
                    :label="item | hkVehicleRegisterType"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbGInsurance.label.admittanceStartDate')"
              >
                <el-date-picker
                  v-model="viewForm.admittanceStartDate"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbGInsurance.label.admittanceEndDate')"
              >
                <el-date-picker
                  v-model="viewForm.admittanceEndDate"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.registrationNo')">
                <el-input v-model="viewForm.registrationNo" disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbGInsurance.label.identificationNo')"
              >
                <el-input v-model="viewForm.identificationNo" disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbGInsurance.label.noticePhone')"
                prop="mobile"
              >
                <div class="m-mobile_row">
                  <el-select
                    v-model="viewForm.authMobileAreaCode"
                    :placeholder="$t('hzmbG.label.mobileAreaCode')"
                    disabled
                  >
                    <el-option
                      v-for="item in areas"
                      :key="item.value"
                      :value="item.value"
                      :label="item.text"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model.number="viewForm.authMobile"
                    disabled
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <form-box v-if="form" :title="$t('hzmbGInsurance.title.boxTitle1')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item
                prop="mainlandInsuranceNo"
                :label="$t('hzmbGInsurance.label.mainlandInsuranceNo')"
                :rules="[
                  ruleList.notNull,
                  {
                    pattern: /^[A-Za-z0-9 !@#$%^&*()_+=[\]{};:',.<>/\|-]*$/,
                    message: $t('hzmbGInsurance.message.noChinese'),
                  },
                ]"
              >
                <el-input v-model="form.mainlandInsuranceNo" maxlength="50" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbGInsurance.label.mainlandInsuranceStartDate')"
                :rules="[ruleList.notNull]"
                prop="mainlandInsuranceStartDate"
              >
                <el-date-picker
                  v-model="form.mainlandInsuranceStartDate"
                  :picker-options="{
                    disabledDate: (time) => setStartDateOff(time),
                  }"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbGInsurance.label.mainlandInsuranceEndDate')"
                :rules="[ruleList.notNull, ruleList.endDateCheck]"
                prop="mainlandInsuranceEndDate"
              >
                <el-date-picker
                  v-model="form.mainlandInsuranceEndDate"
                  :picker-options="{
                    disabledDate: (time) => setEndDateOff(time),
                  }"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
    </el-form>
    <!--  -->
    <div class="next_btn">
      <GradientBtn @click="onSubmit" :loading="submitLoading"
        >{{ $t("message.DataRegistration.formData.next") }}
      </GradientBtn>
    </div>
    <!--  -->
  </div>
</template>

<script>
import HzmbGInsuranceApplicationApi from "@/api/hzmb-gh/HzmbGInsuranceApplicationApi";
import GradientBtn from "@/components/GradientBtn.vue";
import { HKVEHICLEREGISTERTYPE } from "@/enums";
import { hkVehicleRegisterType } from "@/filters";
import FormBox from "../components/FormBox.vue";

export default {
  components: { FormBox, GradientBtn },
  filters: { hkVehicleRegisterType },
  data() {
    return {
      serviceType: this.$route.meta.serviceType,
      applicationId: this.$route.query.applicationId,
      loading: false,
      submitLoading: false,
      form: {},
      viewForm: {},
      HKVEHICLEREGISTERTYPE,
      areas: [
        { value: "853", text: this.$t("hzmbG.enum.areas.macau") },
        { value: "852", text: this.$t("hzmbG.enum.areas.hongkong") },
      ],
      ruleList: {
        notNull: {
          required: true,
          message: this.$t("message.formRuleMessage.notNull"),
        },
        email: {
          type: "email",
          message: this.$t("message.formRuleMessage.email"),
          trigger: ["change"],
        },
        endDateCheck: {
          validator: this.mainlandInsuranceEndDateCheck,
          trigger: ["change", "blur"],
        },
      },
    };
  },
  computed: {},
  methods: {
    // 獲取、設置基本信息
    async get() {
      try {
        this.loading = true;

        let form = await HzmbGInsuranceApplicationApi.getById(
          this.applicationId
        );
        form.authMobileAreaCode = form.authMobile.slice(0, 3);
        form.authMobile = form.authMobile.slice(3);
        this.$set(this, "viewForm", { ...form });
        let {
          mainlandInsuranceNo,
          mainlandInsuranceStartDate,
          mainlandInsuranceEndDate,
        } = form;

        if (mainlandInsuranceNo)
          this.$set(this, "form", {
            mainlandInsuranceNo,
            mainlandInsuranceStartDate,
            mainlandInsuranceEndDate,
          });
      } catch (error) {
        if (error.code === "DUPLICATE_APPROVING_APPLICATION") {
          this.$alert(
            this.$t("message.ErrorMessage.DUPLICATE_APPROVING_APPLICATION")
          );
          this.$router.replace(`/hzmb-truck-hk`);
        } else {
          this.$error(error);
        }
      } finally {
        this.loading = false;
      }
    },
    // 設置日期禁用
    setStartDateOff(event) {
      let { mainlandInsuranceEndDate } = this.form;
      if (mainlandInsuranceEndDate) {
        return !(
          new Date(event).getTime() <=
          new Date(mainlandInsuranceEndDate).getTime()
        );
      } else {
        return false;
      }
    },
    // 設置日期禁用
    setEndDateOff(event) {
      let { mainlandInsuranceStartDate } = this.form;
      if (mainlandInsuranceStartDate) {
        return !(
          new Date(event).getTime() >=
          new Date(mainlandInsuranceStartDate).getTime()
        );
      } else {
        return false;
      }
    },
    //
    mainlandInsuranceEndDateCheck(rule, value, callback) {
      var current = value ? new Date(value).getTime() : 0;
      let admittanceStartDate = new Date(
        this.viewForm.admittanceStartDate
      ).getTime();

      if (current < admittanceStartDate) {
        let msg = "保險單結束日期不能小於允許駛入澳門開始日期";
        callback(new Error(msg));
      } else {
        callback();
      }
    },
    // 提交驗證
    onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.doSubmit();
        } else {
          this.$message({
            type: "error",
            message: this.$t("message.form_error"),
          });
        }
      });
    },
    // 提交
    async doSubmit() {
      try {
        this.submitLoading = true;
        let {
          approveNo,
          identificationNo,
          registrationNo,
          identityType,
          identityNo,
        } = this.viewForm;
        await HzmbGInsuranceApplicationApi.tempSave({
          id: this.applicationId,
          approveNo,
          identificationNo,
          registrationNo,
          identityNo,
          identityType,
          ...this.form,
        });

        this.$router.push({
          path: `/hzmb-g-insurance/upload`,
          query: { applicationId: this.applicationId },
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, data, name) {
      data[name] = val.toUpperCase();
    },
  },
  created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
.el-input-number__decrease,
.el-input-number__increase {
  height: 46px;
}
.el-input-number {
  line-height: 46px;
}
.m-form__items {
  .el-textarea {
    margin-bottom: 8px;
  }
}
.el-row {
  align-items: flex-start;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
}
.vehicle-size-row {
  .el-form-item + .el-form-item {
    margin-top: 22px;
  }
}
.add_driver {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.m-form-item__custom:after {
  content: "" !important;
}
.m-form-item__custom .m-is-quired:after {
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
}
.warn-icon {
  font-size: 18px;
  line-height: 38px;
  margin-left: 6px;
  cursor: pointer;
}

.m-popover-table {
  /deep/table {
    width: 100% !important;
  }
  /deep/th {
    background: #5ba7ad !important;
    color: #fff;
    text-align: center;
    padding: 6px 0;
  }
  /deep/td {
    text-align: center;
  }
}
/deep/.vehicle-size__tips {
  color: #ffa500;
  padding: 3px 0;
  font-size: 14px;
}

/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/deep/input[type="number"] {
  -moz-appearance: textfield;
}
/deep/.el-input__prefix .el-icon-search {
  font-size: 18px;
  position: relative;
  top: 4px;
  left: 2px;
}
</style>
